// Popup to display area name, logo, and children if provided on the map
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faRoute } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import GlobalStoreContext from "../../context/GlobalStoreContext";
import { Area } from "../../models/Area";
import { Dropoff } from "../../models/Dropoff";
import { Equipment } from "../../models/Equipment";
import { Gate } from "../../models/Gate";
import { GateToDropoffRoute } from "../../models/GateToDropoffRoute";
import { HaulRoute } from "../../models/HaulRoute";
import { MapObject } from "../../models/MapObject";
import AreaAvatar from "./AreaAvatar";

interface Props {
    mapObject: MapObject;
    mappable?: Area | Dropoff | Equipment | Gate | HaulRoute | GateToDropoffRoute | null;

    children?: any;
}

const mappableName = (
    mappable: Area | Dropoff | Equipment | Gate | HaulRoute | GateToDropoffRoute
): string | null | undefined => {
    if (mappable instanceof Area) {
        return mappable.areaName;
    }
    if (mappable instanceof Equipment) {
        return mappable.equipmentName;
    }
    return mappable.name;
};

const MapPopup: React.FC<Props> = ({ mapObject, mappable, children }) => {
    const context = React.useContext(GlobalStoreContext);
    if (!mappable) {
        return (
            <div className="flex flex-col items-center">
                <div className="text-plot-slate font-plot-oswald font-semibold text-xl">Unknown</div>
            </div>
        );
    }

    if (mappable instanceof GateToDropoffRoute) {
        const gate = context.gatesForProject(context.currentProjectInfo.id).find((g) => g.id === mappable.gateId);
        const dropoff = context
            .dropoffsForProject(context.currentProjectInfo.id)
            .find((d) => d.id === mappable.dropoffId);
        if (!gate || !dropoff) {
            return (
                <div className="flex flex-col items-center">
                    <div className="text-plot-slate font-plot-oswald font-semibold text-xl">{mappable.name}</div>
                </div>
            );
        }
        return (
            <div className="flex flex-col items-center">
                <div className="flex flex-row gap-2 items-center mr-4 font-plot-oswald font-semibold text-xl text-plot-slate">
                    <FontAwesomeIcon icon={faRoute} />
                    <div>Route for</div>
                    <AreaAvatar mappable={gate} showName={true} size="2rem" />
                    <FontAwesomeIcon icon={faArrowRight} />
                    <AreaAvatar mappable={dropoff} showName={true} size="2rem" />
                </div>
                {children}
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center">
            <div className="flex flex-row items-center mr-4 font-plot-oswald font-semibold text-xl text-plot-slate">
                <AreaAvatar mappable={mappable} showName={true} size="2rem" />
            </div>
            {children}
        </div>
    );
};

export default MapPopup;
